module.exports = __webpack_public_path__ + "static/media/cover.639dbe78.png";